import { render, staticRenderFns } from "./StatsChart.vue?vue&type=template&id=91542e96&"
import script from "./StatsChart.vue?vue&type=script&lang=js&"
export * from "./StatsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports